import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  AssignPermission: {
    to: 'AssignPermissionToRolesListUI',
  },
  BackgroundServerMethodTriggers: {
    icon: 'quartzNetTrigger',
    to: 'BackgroundServerMethodTriggersUI',
  },
  CustomUIViewListUI: {
    icon: 'createCustomView',
    to: 'CustomUIViewListUI',
  },
  Permission: {
    to: 'PermissionUI',
  },
  QuartzNetTests: {
    icon: 'jobAndTriggersTests',
    to: 'QuartzNetTestTriggerUI',
  },
  RemoteAccessTests: {
    icon: 'remoteInvoke',
  },
  RemoteScheduledTaskExecutionList: {
    to: 'RemoteScheduledTaskExecutionListUI',
  },
  RemoteScheduledTaskList: {
    to: 'RemoteScheduledTaskListUI',
  },
  RightsManagement: {
  },
  ScheduledTaskExecutionLogSearch: {
    to: 'ScheduledTaskExecutionLogSearchUI',
  },
  ScheduledTaskExecutionSearch: {
    to: 'ScheduledTaskExecutionSearchUI',
  },
  ScheduledTaskLogs: {
    icon: 'scheduledTaskLogs',
  },
  ScheduledTaskSearch: {
    to: 'ScheduledTaskSearchUI',
  },
  UserAccount: {
    to: 'UserAccountListUI',
  },
  UserAccountUserRole: {
    to: 'UserAccountUserRoleUI',
  },
  UserPermissions: {
  },
  Users: {
  },
  UserSettings: {
    to: 'UserSettingsUI',
  }
}